import React from 'react';

export default function SalonTabs({
  salones,
  salonActivoId,
  onChange,
}) {
  if (salones.length <= 1) {
    return null;
  }

  return (
    <div className="flex gap-2 overflow-x-auto pb-1">
      {salones.map((salon) => {
        const activo = salon.id === salonActivoId;

        return (
          <button
            key={salon.id}
            type="button"
            onClick={() => onChange(salon.id)}
            className={[
              'shrink-0 rounded-xl px-4 py-2.5 text-sm font-bold transition-all',
              activo
                ? 'bg-azul-oscuro text-white shadow-md'
                : 'border border-gray-200 bg-white text-gray-600 hover:border-verde-esmeralda hover:text-verde-oscuro',
            ].join(' ')}
          >
            {salon.nombre}
          </button>
        );
      })}
    </div>
  );
}
